import { i18nText } from '@/components/UI/EFRegion/i18nText';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { isReadyLang } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { setLocalStorage, removeLocalStorage } from '@/utils/localStorage';
import { localsList } from '@/utils/locals';
import { incompleteLocalsList } from '@/constants';

// 代理商网站
export const AGENT_SITE: any = {
    // 欧洲
    hr: 'https://ecoflow.hr/', // 克罗地亚
    cz: 'https://ecoflow.cz/', // 捷克
    dk: 'https://ecoflow.dk/', // 丹麦
    ge: 'https://ge.ecoflow.com/', // 格鲁吉亚
    ie: 'https://www.ecoflow.ie/', // 爱尔兰
    gr: 'https://www.ecoflow.gr/', // 希腊
    no: 'https://www.ecoflow.no/', // 挪威
    pl: 'https://ecoflow.com.pl/', // 波兰
    pt: 'https://ecoflow.com.pt/', // 葡萄牙
    si: 'https://www.ecoflow.si/', // 斯洛文尼亚
    se: 'https://ecoflow.se/', // 瑞典
    ch: 'https://ch.ecoflow.com/', // 瑞士
    tr: 'https://ecoflow.com.tr/', // 土耳其
    kz: 'https://ecoflow.com.kz/', // 哈萨克斯坦

    // 亚洲
    in: 'https://ecoflowindia.com/', // 印度
    id: 'https://powerstation-sts.id/', // 印尼
    my: 'https://ecoflow.com.my/', // 马来西亚
    nz: 'https://ecoflowtech.co.nz/', // 新西兰
    // sg: 'ecoflow.com.sg', // 新加坡
    th: 'https://www.siamef.com/', // 泰国
    vn: 'https://ecoflowvn.vn/', // 越南

    // 南美洲
    ar: 'https://ecoflowstore.com.ar/', // 阿根廷
    br: 'https://ecoflowstore.com.br/', // 巴西
    cl: 'https://ecoflowchile.cl/', // 智利
    co: 'https://www.tienexenergy.co/', // 哥伦比亚
    pe: 'https://ecoflowstore.pe/', // 哥伦比亚

    // 中东
    pk: 'https://ecoflowstore.pk/', // 巴基斯坦
};

export default function Region({ SEO }: any) {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');

    const tabsList = [
        { key: 'p1', text: i18nText[locale]?.region_north_america || i18nText.en.region_north_america, id: 'northAmerica' },
        { key: 'p2', text: i18nText[locale]?.region_europe || i18nText.en.region_europe, id: 'europe' },
        { key: 'p3', text: i18nText[locale]?.region_asia_pacific || i18nText.en.region_asia_pacific, id: 'asiaPacific' },
        { key: 'p4', text: i18nText[locale]?.region_latin || i18nText.en.region_latin, id: 'latin' },
        { key: 'p5', text: i18nText[locale]?.region_africa_middleeast || i18nText.en.region_africa_middleeast, id: 'africa' },
        { key: 'p6', text: i18nText[locale]?.region_global || i18nText.en.region_global, id: 'global' },
    ];

    const changeRegion = async (locale: string, appId: number, acceptLanguage: string, region: string, id: string) => {
        const agent_site = AGENT_SITE[locale];
        if (agent_site) {
            window.open(agent_site);
            return;
        }
        if (isDisabledSite(locale)) return;

        removeLocalStorage('appInfo');
        setLocalStorage('languageRegion', region);
        setLocalStorage('appInfo', {
            appId,
            acceptLanguage,
            locale,
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'change_country',
            button_name: region,
        });
        window.location.href = `https://www.ecoflow.com/${locale}`;
    };

    const isDisabledSite = (currLocal: string) => !isReadyLang(currLocal) || incompleteLocalsList.includes(currLocal);

    return (
        <PageLayout>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <div className={`${css.region} container`}>
                {tabsList.map((item: { key: string; text: string; id: string; type?: string | undefined }) => (
                    <div className="lang-group" key={item.id}>
                        <div className="group-name" id={item.id}>
                            {item.text}
                        </div>
                        <ul className="member-list">
                            {localsList[item.id]?.map(
                                (list: any) =>
                                    (!list?.allowSites || list?.allowSites?.includes(locale)) && (
                                        <li
                                            className="member"
                                            key={list.region}
                                            onClick={() =>
                                                changeRegion(list.local, list.appId, list.acceptLanguage, `${list.region}(${list.language})`, item.id)
                                            }
                                        >
                                            <span className={`region ${!isDisabledSite(list.local) || AGENT_SITE[list.local] ? '' : 'disabled'}`}>
                                                {list.regionText}
                                            </span>
                                            <span className={`lang ${!isDisabledSite(list.local) || AGENT_SITE[list.local] ? '' : 'disabled'}`}>
                                                {!isDisabledSite(list.local) || AGENT_SITE[list.local] ? list.languageText : t('region.comming_soon')}
                                            </span>
                                        </li>
                                    ),
                            )}
                        </ul>
                    </div>
                ))}
            </div>
        </PageLayout>
    );
}
